/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

/**
 * Classification mode:
 * - SINGLE_LABEL: each interaction can have only one category assigned to it.
 * - MULTI_LABEL: each interaction can have multiple categories assigned to it.
 */
export type ClassificationMode = (typeof ClassificationMode)[keyof typeof ClassificationMode];

export const ClassificationMode = {
  single_label: 'single_label',
  multi_label: 'multi_label',
} as const;
